// import { Button } from "@mui/material";
// import React, { useMemo } from "react";
// import styles from "./MyButton.module.css";
// // adjust path as needed

// function debounce(func, delay = 500) {
//   let timer;
//   return (...args) => {
//     if (timer) clearTimeout(timer);
//     timer = setTimeout(() => {
//       func(...args);
//     }, delay);
//   };
// }

// const MyButton = ({
//   btnText,
//   className,
//   type = "button",
//   handler,
//   disabled,
//   children,
//   debounceDelay, // ✅ new prop for debounce (optional)
// }) => {
//   // ✅ wrap handler in debounce only once (memoized)
//   const debouncedHandler = useMemo(() => {
//     if (!handler) return undefined;
//     return debounce(handler, debounceDelay || 600); // default 500ms
//   }, [handler, debounceDelay]);

//   return (
//     <Button
//       variant="contained"
//       type={type}
//       className={[styles.btn, className, disabled && styles.disabled].join(" ")}
//       onClick={debouncedHandler}
//       disabled={disabled}
//     >
//       {btnText || children}
//     </Button>
//   );
// };

// export default MyButton;


import { Button } from "@mui/material";
import React, { useMemo } from "react";
import styles from "./MyButton.module.css";

// ✅ debounce that works with React events
function debounce(func, delay = 500) {
  let timer;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

const MyButton = ({
  btnText,
  className,
  type = "button",
  handler,
  disabled,
  children,
  debounceDelay, // ✅ optional debounce delay
}) => {
  // ✅ wrap handler in debounce only once (memoized)
  const debouncedHandler = useMemo(() => {
    if (!handler) return undefined;
    return debounce((event, ...rest) => {
      if (event?.persist) event.persist(); // ✅ keep React event alive
      handler(event, ...rest);
    }, debounceDelay || 600);
  }, [handler, debounceDelay]);

  return (
    <Button
      variant="contained"
      type={type}
      className={[styles.btn, className, disabled && styles.disabled].join(" ")}
      onClick={debouncedHandler}
      disabled={disabled}
    >
      {btnText || children}
    </Button>
  );
};

export default MyButton;
